/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ui-license-chart .mat-card .chart-content{height:300px}ui-license-chart ui-suggest.tenant-list-select .item-list-container .mat-list virtual-scroller{max-height:300px}"];
export { styles as styles };
